import { Button } from "@exhousing/design-system";
import type { ComponentType, ReactNode } from "react";

/** Consistent first-run empty state: icon + what-this-is + a primary action. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void } | ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card/40 px-6 py-16 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-muted">
        <Icon className="size-6 text-muted-foreground" />
      </div>
      <h3 className="mt-4 font-display text-lg font-medium">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {action &&
        (typeof action === "object" && "label" in action ? (
          <Button className="mt-5" onClick={action.onClick}>
            {action.label}
          </Button>
        ) : (
          <div className="mt-5">{action}</div>
        ))}
    </div>
  );
}
